/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: rvlEtCxpePtd

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import SectionHeader from "../../SectionHeader"; // plasmic-import: BZA1gY3bmqLJ/component
import { StateProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/StateProvider/StateProvider"; // plasmic-import: OaGu0RHjgthJ/codeComponent
import { DataProvider } from "@plasmicpkgs/plasmic-basic-components";
import RoundButton from "../../RoundButton"; // plasmic-import: G_YIM-U5ADf4/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { SliderWrapper } from "@plasmicpkgs/react-slick";
import { sliderHelpers as SliderWrapper_Helpers } from "@plasmicpkgs/react-slick";
import HomeCaseStudiesSectionBanner from "../../HomeCaseStudiesSectionBanner"; // plasmic-import: z42h7wgleYEz/component
import Bullet from "../../Bullet"; // plasmic-import: UscJzz0L99iP/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomeCaseStudiesSection.module.css"; // plasmic-import: rvlEtCxpePtd/css

import IconSmall16ArrowLeftIcon from "./icons/PlasmicIcon__IconSmall16ArrowLeft"; // plasmic-import: riMR0R0MN6nG/icon
import IconSmall16ArrowRightIcon from "./icons/PlasmicIcon__IconSmall16ArrowRight"; // plasmic-import: l8UOQ-rhgLow/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicHomeCaseStudiesSection__VariantMembers = {};
export type PlasmicHomeCaseStudiesSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeCaseStudiesSection__VariantsArgs;
export const PlasmicHomeCaseStudiesSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeCaseStudiesSection__ArgsType = {};
type ArgPropType = keyof PlasmicHomeCaseStudiesSection__ArgsType;
export const PlasmicHomeCaseStudiesSection__ArgProps = new Array<ArgPropType>();

export type PlasmicHomeCaseStudiesSection__OverridesType = {
  caseStudies?: Flex__<"section">;
  desktop?: Flex__<"div">;
  img?: Flex__<typeof PlasmicImg__>;
  wrapper?: Flex__<"div">;
  row?: Flex__<"div">;
  sectionHeader?: Flex__<typeof SectionHeader>;
  bannerVariantProvider?: Flex__<typeof StateProvider>;
  bannerLabelProvider?: Flex__<typeof DataProvider>;
  banner?: Flex__<"div">;
  nav?: Flex__<"div">;
  left?: Flex__<"div">;
  navBackButton?: Flex__<typeof RoundButton>;
  navForwardButton?: Flex__<typeof RoundButton>;
  allCaseStudiesButton?: Flex__<typeof Button>;
  bannerContainer?: Flex__<"div">;
  sliderCarousel?: Flex__<typeof SliderWrapper>;
  sliderNavigation?: Flex__<"div">;
  navigationBullet?: Flex__<typeof Bullet>;
  buttonWrapper?: Flex__<"div">;
  allCaseStudiesButton2?: Flex__<typeof Button>;
};

export interface DefaultHomeCaseStudiesSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeCaseStudiesSection__RenderFunc(props: {
  variants: PlasmicHomeCaseStudiesSection__VariantsArgs;
  args: PlasmicHomeCaseStudiesSection__ArgsType;
  overrides: PlasmicHomeCaseStudiesSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "bannerVariantProvider.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "sliderCarousel.currentSlide",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0,

        refName: "sliderCarousel",
        onMutate: generateOnMutateForSpec("currentSlide", SliderWrapper_Helpers)
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"caseStudies"}
      data-plasmic-override={overrides.caseStudies}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.caseStudies
      )}
    >
      <div
        data-plasmic-name={"desktop"}
        data-plasmic-override={overrides.desktop}
        className={classNames("all", sty.desktop)}
      >
        {(
          hasVariant(globalVariants, "mobile", "mobile")
            ? false
            : hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? false
              : true
        ) ? (
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"900px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"1200px"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/f8c2846a1d939511f6aa136587f7afe2.svg",
              fullWidth: 895,
              fullHeight: 1068,
              aspectRatio: 0.838015
            }}
          />
        ) : null}
        <div
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}
          className={classNames("all", sty.wrapper)}
        >
          <div
            data-plasmic-name={"row"}
            data-plasmic-override={overrides.row}
            className={classNames("all", sty.row)}
          >
            <SectionHeader
              data-plasmic-name={"sectionHeader"}
              data-plasmic-override={overrides.sectionHeader}
              className={classNames("__wab_instance", sty.sectionHeader)}
              description={
                "For nearly 30 years, MyEvaluations has partnered with medical education institutions to support the people who shape the future of healthcare.\nOur commitment extends beyond software. We partner with educators to strengthen assessment quality, deliver\u00a0meaningful educational insight, and support better decisions through Continuous Educational Improvement.\nBecause better education leads to better healthcare."
              }
              showDescription={true}
              showSubtitle={true}
              subtitle={"Trusted Through Partnership"}
              title={"Advancing Medical Education for Nearly Three Decades"}
            />
          </div>
          <StateProvider
            data-plasmic-name={"bannerVariantProvider"}
            data-plasmic-override={overrides.bannerVariantProvider}
            defaultValue={"usc"}
            onChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "bannerVariantProvider",
                "value"
              ]).apply(null, eventArgs);
            }}
            value={generateStateValueProp($state, [
              "bannerVariantProvider",
              "value"
            ])}
          />

          <DataProvider
            data-plasmic-name={"bannerLabelProvider"}
            data-plasmic-override={overrides.bannerLabelProvider}
            className={classNames("__wab_instance", sty.bannerLabelProvider)}
            data={[{ label: "usc" }, { label: "meharry" }, { label: "uconn" }]}
            name={"banners"}
          >
            <DataCtxReader__>
              {$ctx => (
                <div
                  data-plasmic-name={"banner"}
                  data-plasmic-override={overrides.banner}
                  className={classNames("all", sty.banner)}
                >
                  {(
                    hasVariant(globalVariants, "mobile", "mobile")
                      ? false
                      : true
                  ) ? (
                    <div
                      data-plasmic-name={"nav"}
                      data-plasmic-override={overrides.nav}
                      className={classNames("all", sty.nav)}
                    >
                      <div
                        data-plasmic-name={"left"}
                        data-plasmic-override={overrides.left}
                        className={classNames("all", sty.left)}
                      >
                        <RoundButton
                          data-plasmic-name={"navBackButton"}
                          data-plasmic-override={overrides.navBackButton}
                          ariaLabel={"Show previous banner"}
                          className={classNames(
                            "__wab_instance",
                            sty.navBackButton
                          )}
                          color={"sky"}
                          icon={
                            <IconSmall16ArrowLeftIcon
                              className={classNames("all", sty.svg__fouXh)}
                              role={"img"}
                            />
                          }
                          onClick={async event => {
                            const $steps = {};

                            $steps["updateSliderCarouselCurrentSlide"] = true
                              ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: [
                                        "sliderCarousel",
                                        "currentSlide"
                                      ]
                                    },
                                    operation: 0,
                                    value:
                                      $state.sliderCarousel.currentSlide - 1
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } = variable;

                                    $stateSet(objRoot, variablePath, value);
                                    return value;
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["updateSliderCarouselCurrentSlide"] !=
                                null &&
                              typeof $steps[
                                "updateSliderCarouselCurrentSlide"
                              ] === "object" &&
                              typeof $steps["updateSliderCarouselCurrentSlide"]
                                .then === "function"
                            ) {
                              $steps["updateSliderCarouselCurrentSlide"] =
                                await $steps[
                                  "updateSliderCarouselCurrentSlide"
                                ];
                            }
                          }}
                          size={"large"}
                        />

                        <RoundButton
                          data-plasmic-name={"navForwardButton"}
                          data-plasmic-override={overrides.navForwardButton}
                          ariaLabel={"Show next banner"}
                          className={classNames(
                            "__wab_instance",
                            sty.navForwardButton
                          )}
                          color={"sky"}
                          icon={
                            <IconSmall16ArrowRightIcon
                              className={classNames("all", sty.svg__daIjG)}
                              role={"img"}
                            />
                          }
                          onClick={async event => {
                            const $steps = {};

                            $steps["updateSliderCarouselCurrentSlide"] = true
                              ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: [
                                        "sliderCarousel",
                                        "currentSlide"
                                      ]
                                    },
                                    operation: 0,
                                    value:
                                      $state.sliderCarousel.currentSlide + 1
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } = variable;

                                    $stateSet(objRoot, variablePath, value);
                                    return value;
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["updateSliderCarouselCurrentSlide"] !=
                                null &&
                              typeof $steps[
                                "updateSliderCarouselCurrentSlide"
                              ] === "object" &&
                              typeof $steps["updateSliderCarouselCurrentSlide"]
                                .then === "function"
                            ) {
                              $steps["updateSliderCarouselCurrentSlide"] =
                                await $steps[
                                  "updateSliderCarouselCurrentSlide"
                                ];
                            }
                          }}
                          size={"large"}
                        />
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"allCaseStudiesButton"}
                          data-plasmic-override={overrides.allCaseStudiesButton}
                          className={classNames(
                            "__wab_instance",
                            sty.allCaseStudiesButton
                          )}
                          color={"sky"}
                          size={"large"}
                        >
                          {"ALL CASE STUDIES"}
                        </Button>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"bannerContainer"}
                    data-plasmic-override={overrides.bannerContainer}
                    className={classNames("all", sty.bannerContainer)}
                  >
                    {(() => {
                      const child$Props = {
                        accessibility: true,
                        arrows: false,
                        autoplay: false,
                        beforeChange: async (...eventArgs: any) => {
                          generateStateOnChangePropForCodeComponents(
                            $state,
                            "currentSlide",
                            ["sliderCarousel", "currentSlide"],
                            SliderWrapper_Helpers
                          ).apply(null, eventArgs);
                        },
                        centerMode: false,
                        className: classNames(
                          "__wab_instance",
                          sty.sliderCarousel
                        ),
                        dots: false,
                        draggable: true,
                        infinite: true,
                        initialSlide: generateStateValueProp($state, [
                          "sliderCarousel",
                          "currentSlide"
                        ]),
                        ref: ref => {
                          $refs["sliderCarousel"] = ref;
                        },
                        sliderScopeClassName: sty["sliderCarousel__slider"]
                      };
                      initializeCodeComponentStates(
                        $state,
                        [
                          {
                            name: "currentSlide",
                            plasmicStateName: "sliderCarousel.currentSlide"
                          }
                        ],
                        [],
                        SliderWrapper_Helpers ?? {},
                        child$Props
                      );

                      return (
                        <SliderWrapper
                          data-plasmic-name={"sliderCarousel"}
                          data-plasmic-override={overrides.sliderCarousel}
                          {...child$Props}
                        >
                          <div
                            className={classNames("all", sty.freeBox__drdSu)}
                          >
                            <HomeCaseStudiesSectionBanner
                              className={classNames(
                                "__wab_instance",
                                sty.homeCaseStudiesSectionBanner__ypcO
                              )}
                              type={"usc"}
                            />
                          </div>
                          <div
                            className={classNames("all", sty.freeBox___5ME2)}
                          >
                            <HomeCaseStudiesSectionBanner
                              className={classNames(
                                "__wab_instance",
                                sty.homeCaseStudiesSectionBanner___1OTky
                              )}
                              type={"meharry"}
                            />
                          </div>
                          <div
                            className={classNames("all", sty.freeBox__uFkPq)}
                          >
                            <HomeCaseStudiesSectionBanner
                              className={classNames(
                                "__wab_instance",
                                sty.homeCaseStudiesSectionBanner___2OdIq
                              )}
                              type={"uconn"}
                            />
                          </div>
                        </SliderWrapper>
                      );
                    })()}
                    <div
                      data-plasmic-name={"sliderNavigation"}
                      data-plasmic-override={overrides.sliderNavigation}
                      className={classNames("all", sty.sliderNavigation)}
                    >
                      {(_par =>
                        !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                        (() => {
                          try {
                            return $ctx.banners;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return [];
                            }
                            throw e;
                          }
                        })()
                      ).map((__plasmic_item_0, __plasmic_idx_0) => {
                        const currentItem = __plasmic_item_0;
                        const currentIndex = __plasmic_idx_0;
                        return (
                          <Bullet
                            data-plasmic-name={"navigationBullet"}
                            data-plasmic-override={overrides.navigationBullet}
                            active={(() => {
                              try {
                                return (
                                  $state.sliderCarousel.currentSlide ===
                                    currentIndex ||
                                  (currentIndex === 2 &&
                                    $state.sliderCarousel.currentSlide === 3) ||
                                  (currentIndex === 0 &&
                                    $state.sliderCarousel.currentSlide === -1)
                                );
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()}
                            ariaLabel={(() => {
                              try {
                                return currentItem.label;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()}
                            className={classNames(
                              "__wab_instance",
                              sty.navigationBullet
                            )}
                            key={currentIndex}
                            onClick={async () => {
                              const $steps = {};

                              $steps["updateSliderCarouselCurrentSlide"] = true
                                ? (() => {
                                    const actionArgs = {
                                      variable: {
                                        objRoot: $state,
                                        variablePath: [
                                          "sliderCarousel",
                                          "currentSlide"
                                        ]
                                      },
                                      operation: 0,
                                      value: currentIndex
                                    };
                                    return (({
                                      variable,
                                      value,
                                      startIndex,
                                      deleteCount
                                    }) => {
                                      if (!variable) {
                                        return;
                                      }
                                      const { objRoot, variablePath } =
                                        variable;

                                      $stateSet(objRoot, variablePath, value);
                                      return value;
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["updateSliderCarouselCurrentSlide"] !=
                                  null &&
                                typeof $steps[
                                  "updateSliderCarouselCurrentSlide"
                                ] === "object" &&
                                typeof $steps[
                                  "updateSliderCarouselCurrentSlide"
                                ].then === "function"
                              ) {
                                $steps["updateSliderCarouselCurrentSlide"] =
                                  await $steps[
                                    "updateSliderCarouselCurrentSlide"
                                  ];
                              }
                            }}
                          />
                        );
                      })}
                    </div>
                    {(
                      hasVariant(globalVariants, "mobile", "mobile")
                        ? true
                        : false
                    ) ? (
                      <div
                        data-plasmic-name={"buttonWrapper"}
                        data-plasmic-override={overrides.buttonWrapper}
                        className={classNames("all", sty.buttonWrapper)}
                      >
                        {(
                          hasVariant(globalVariants, "mobile", "mobile")
                            ? false
                            : true
                        ) ? (
                          <Button
                            data-plasmic-name={"allCaseStudiesButton2"}
                            data-plasmic-override={
                              overrides.allCaseStudiesButton2
                            }
                            className={classNames(
                              "__wab_instance",
                              sty.allCaseStudiesButton2
                            )}
                            color={"sky"}
                            size={"large"}
                          >
                            {"ALL CASE STUDIES"}
                          </Button>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
            </DataCtxReader__>
          </DataProvider>
        </div>
      </div>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  caseStudies: [
    "caseStudies",
    "desktop",
    "img",
    "wrapper",
    "row",
    "sectionHeader",
    "bannerVariantProvider",
    "bannerLabelProvider",
    "banner",
    "nav",
    "left",
    "navBackButton",
    "navForwardButton",
    "allCaseStudiesButton",
    "bannerContainer",
    "sliderCarousel",
    "sliderNavigation",
    "navigationBullet",
    "buttonWrapper",
    "allCaseStudiesButton2"
  ],
  desktop: [
    "desktop",
    "img",
    "wrapper",
    "row",
    "sectionHeader",
    "bannerVariantProvider",
    "bannerLabelProvider",
    "banner",
    "nav",
    "left",
    "navBackButton",
    "navForwardButton",
    "allCaseStudiesButton",
    "bannerContainer",
    "sliderCarousel",
    "sliderNavigation",
    "navigationBullet",
    "buttonWrapper",
    "allCaseStudiesButton2"
  ],
  img: ["img"],
  wrapper: [
    "wrapper",
    "row",
    "sectionHeader",
    "bannerVariantProvider",
    "bannerLabelProvider",
    "banner",
    "nav",
    "left",
    "navBackButton",
    "navForwardButton",
    "allCaseStudiesButton",
    "bannerContainer",
    "sliderCarousel",
    "sliderNavigation",
    "navigationBullet",
    "buttonWrapper",
    "allCaseStudiesButton2"
  ],
  row: ["row", "sectionHeader"],
  sectionHeader: ["sectionHeader"],
  bannerVariantProvider: ["bannerVariantProvider"],
  bannerLabelProvider: [
    "bannerLabelProvider",
    "banner",
    "nav",
    "left",
    "navBackButton",
    "navForwardButton",
    "allCaseStudiesButton",
    "bannerContainer",
    "sliderCarousel",
    "sliderNavigation",
    "navigationBullet",
    "buttonWrapper",
    "allCaseStudiesButton2"
  ],
  banner: [
    "banner",
    "nav",
    "left",
    "navBackButton",
    "navForwardButton",
    "allCaseStudiesButton",
    "bannerContainer",
    "sliderCarousel",
    "sliderNavigation",
    "navigationBullet",
    "buttonWrapper",
    "allCaseStudiesButton2"
  ],
  nav: [
    "nav",
    "left",
    "navBackButton",
    "navForwardButton",
    "allCaseStudiesButton"
  ],
  left: ["left", "navBackButton", "navForwardButton"],
  navBackButton: ["navBackButton"],
  navForwardButton: ["navForwardButton"],
  allCaseStudiesButton: ["allCaseStudiesButton"],
  bannerContainer: [
    "bannerContainer",
    "sliderCarousel",
    "sliderNavigation",
    "navigationBullet",
    "buttonWrapper",
    "allCaseStudiesButton2"
  ],
  sliderCarousel: ["sliderCarousel"],
  sliderNavigation: ["sliderNavigation", "navigationBullet"],
  navigationBullet: ["navigationBullet"],
  buttonWrapper: ["buttonWrapper", "allCaseStudiesButton2"],
  allCaseStudiesButton2: ["allCaseStudiesButton2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  caseStudies: "section";
  desktop: "div";
  img: typeof PlasmicImg__;
  wrapper: "div";
  row: "div";
  sectionHeader: typeof SectionHeader;
  bannerVariantProvider: typeof StateProvider;
  bannerLabelProvider: typeof DataProvider;
  banner: "div";
  nav: "div";
  left: "div";
  navBackButton: typeof RoundButton;
  navForwardButton: typeof RoundButton;
  allCaseStudiesButton: typeof Button;
  bannerContainer: "div";
  sliderCarousel: typeof SliderWrapper;
  sliderNavigation: "div";
  navigationBullet: typeof Bullet;
  buttonWrapper: "div";
  allCaseStudiesButton2: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeCaseStudiesSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeCaseStudiesSection__VariantsArgs;
    args?: PlasmicHomeCaseStudiesSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeCaseStudiesSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeCaseStudiesSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeCaseStudiesSection__ArgProps,
          internalVariantPropNames: PlasmicHomeCaseStudiesSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeCaseStudiesSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "caseStudies") {
    func.displayName = "PlasmicHomeCaseStudiesSection";
  } else {
    func.displayName = `PlasmicHomeCaseStudiesSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeCaseStudiesSection = Object.assign(
  // Top-level PlasmicHomeCaseStudiesSection renders the root element
  makeNodeComponent("caseStudies"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    img: makeNodeComponent("img"),
    wrapper: makeNodeComponent("wrapper"),
    row: makeNodeComponent("row"),
    sectionHeader: makeNodeComponent("sectionHeader"),
    bannerVariantProvider: makeNodeComponent("bannerVariantProvider"),
    bannerLabelProvider: makeNodeComponent("bannerLabelProvider"),
    banner: makeNodeComponent("banner"),
    nav: makeNodeComponent("nav"),
    left: makeNodeComponent("left"),
    navBackButton: makeNodeComponent("navBackButton"),
    navForwardButton: makeNodeComponent("navForwardButton"),
    allCaseStudiesButton: makeNodeComponent("allCaseStudiesButton"),
    bannerContainer: makeNodeComponent("bannerContainer"),
    sliderCarousel: makeNodeComponent("sliderCarousel"),
    sliderNavigation: makeNodeComponent("sliderNavigation"),
    navigationBullet: makeNodeComponent("navigationBullet"),
    buttonWrapper: makeNodeComponent("buttonWrapper"),
    allCaseStudiesButton2: makeNodeComponent("allCaseStudiesButton2"),

    // Metadata about props expected for PlasmicHomeCaseStudiesSection
    internalVariantProps: PlasmicHomeCaseStudiesSection__VariantProps,
    internalArgProps: PlasmicHomeCaseStudiesSection__ArgProps
  }
);

export default PlasmicHomeCaseStudiesSection;
/* prettier-ignore-end */
